import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { Button, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { Schedule } from '../../modules/schedules';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface DependScheduleListComponentProps {
  data: Schedule[];
  openDependAddModal: () => void;
}

function DependScheduleListComponent({
  data,
  openDependAddModal,
}: DependScheduleListComponentProps) {
  const columns: ColumnsType<Schedule> = [
    {
      title: '이름',
      dataIndex: 'name',
      ellipsis: true,
      width: '11%',
      render: (text: any, record: any) => (
        <>
          {/* <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage('' + record.id)}
          >
            {text}
          </span> */}
          {text}
        </>
      ),
    },
    {
      title: '진행률',
      dataIndex: 'complete',
      width: '10%',
      render: (text: any, record: any, index: any) => `${record.complete}%`,
    },
    {
      title: '공정',
      dataIndex: 'gongjong',
      ellipsis: true,
      render: (text: any, record: any) => <>{text === null ? '기타' : text}</>,
      sorter: (a: Schedule, b: Schedule) =>
        a.gongjong === null || b.gongjong === null
          ? -1
          : a.gongjong.localeCompare(b.gongjong),
      width: '7%',
    },
    {
      title: '시작일',
      dataIndex: 'startDate',
      width: '10%',
      render: (text: any, record: any, index: any) =>
        record.startDate === null
          ? ''
          : moment(record.startDate).format('YYYY-MM-DD'),
    },
    {
      title: '종료일',
      dataIndex: 'finishDate',
      width: '10%',
      render: (text: any, record: any, index: any) =>
        record.finishDate === null
          ? ''
          : moment(record.finishDate).format('YYYY-MM-DD'),
    },
  ];

  return (
    <StyledDiv>
      <Row justify={'space-between'} style={{ marginTop: '50px' }}>
        <Col>
          <Title level={5}>의존공정</Title>
        </Col>
        <Col>
          <Button size="small" onClick={() => openDependAddModal()}>
            변경
          </Button>
        </Col>
      </Row>

      {data && (
        <Table<Schedule>
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
        />
      )}
    </StyledDiv>
  );
}
export default DependScheduleListComponent;
